 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axios from '../../config/axios'
import instance from '../../config/skillmeoaxios'
import instancemooc from '../../config/moocaxios'
import instancesocial from '../../config/socialaxios'

const apiLoginSocialAuthCode = async (authorize_code) => {
	try {
		const result = await instancesocial.post(`/auth/sso`, authorize_code)
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _ => _.response]);
	}
}
const apiLoginWithAuthCode = async (authorize_code) => {
	try {
		const result = await instance.post(`/bma-sso/login`, authorize_code)
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _2 => _2.response]);
	}
}
const apiLoginMoocAuthCode = async (authorize_code) => {
	try {
		const result = await instancemooc.post(`/v1/auth/login/sso`, authorize_code)
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _3 => _3.response]);
	}
}

const apiLogin = async (payload) => {
	try {
		const result = await axios.post(`/auth/login_password`, payload)
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _4 => _4.response]);
	}
}

const apiLogout = async () => {
	try {
		const result = await axios.post(`/auth/logout`, {
		})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _5 => _5.response]);
	}
}

const apiGetAuthorizeCode = async (app_code) => {
	try {
		const result = await axios.post(
			`/auth/authorize_code/grant`,
			{ app_code: app_code },
			{
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('token'),
				},
			}
		)
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _6 => _6.response]);
	}
}

const apiDeleteAuth = async () => {
	try {
		const result = await instancemooc.delete(`/v1/user/auth/my`,{
		headers: {
			Authorization: "Bearer " + localStorage.getItem("mooc_token"),
		}})
		return result
	} catch (error) {
		return _optionalChain([error, 'optionalAccess', _7 => _7.response]);
	}
}

const apiSendForgotPassword = async (email) => {
	await axios.post(`/user/request_reset_password`, { email: email })
	return true
}

const apiCheckForgotPasswordToken = async (token) => {
	let chk = await axios.get(`/user/reset_token/` + token)
	return chk.data
}

const apiRedeemForgotPasswordToken = async (token, password) => {
	await axios.post(`/user/reset_password`, { token: token, password: password })
	return true
}

const apiRedeemResetPasswordToken = async (token, password) => {
	await axios.post(`/user/sso_reset_password`, { token: token, password: password })
	return true
}
export { apiLogin, apiLogout, apiDeleteAuth, apiSendForgotPassword, apiCheckForgotPasswordToken, apiRedeemForgotPasswordToken, apiGetAuthorizeCode, apiLoginWithAuthCode , apiLoginMoocAuthCode,apiLoginSocialAuthCode,apiRedeemResetPasswordToken }
